import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import './AuthLayout.scss';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';
import { LogoColor } from '@assets/images';

type AuthLayoutProps = object;

const AuthLayout: FC<AuthLayoutProps> = () => (
  <div className='AuthLayout'>
    <div className='logoNabla'>
      <img className='authLogo' src={LogoColor} alt='Logo' />
    </div>

    <div className='authContent'>
      <Typography className='titleNabla' variant='h1'>
        受付管理システム
      </Typography>
      <Paper>
        <Outlet />
      </Paper>
    </div>
  </div>
);

export default AuthLayout;
